import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.feature-sets.customize-purchase-order-form-view`

export default defineMessages({
  disclaimerTabLabel: {
    id: `${scope}.disclaimerTabLabel`,
    defaultMessage: 'Disclaimer/labels',
  },
  shippingTermsTabLabel: {
    id: `${scope}.shippingTermsTabLabel`,
    defaultMessage: 'Shipping terms',
  },
  paymentTermsTabLabel: {
    id: `${scope}.paymentTermsTabLabel`,
    defaultMessage: 'Payment terms',
  },
  shippingMethodsTabLabel: {
    id: `${scope}.shippingMethodsTabLabel`,
    defaultMessage: 'Shipping methods',
  },
  poPdfLabelsTabLabel: {
    id: `${scope}.poPdfLabelsTabLabel`,
    defaultMessage: 'PO PDF labels',
  },
  poPdfCustomFieldsTabLabel: {
    id: `${scope}.poPdfCustomFieldsTabLabel`,
    defaultMessage: 'PO PDF custom fields',
  },
})
